import * as React from 'react';
import { css, useProp } from '@joeybright/compose';

interface Props { }

const Form: React.FunctionComponent<Props> = props => {
    const [name, setName] = useProp({
        type: "string",
        name: "Name",
        value: ""
    });

    const [guests, setGuests] = useProp({
        type: "string",
        name: "Guests",
        value: ""
    });

    const [openForm, setOpenForm] = useProp({
        type: "boolean",
        name: "Has Dietary Preferences",
        value: false
    });

    const labelStyles = css({
        fontSize: "14px",
        color: "black",
        width: "100%",
        display: "block",
        paddingBottom: "8px"
    })

    const textInputStyles = css({
        width: "100%",
        borderRadius: "4px",
        border: "1px solid #bfbfbf",
        padding: "8px",
        fontSize: "16px"
    })

    const inputContainerStyles = css({
        paddingBottom: "16px",
        width: "100%"
    })

    const buttonStyles = css({
        fontSize: "16px",
        padding: "8px 16px",
        width: "100%",
        borderRadius: "4px",
        backgroundColor: "#1161A6",
        color: "white",
        border: "none",
        textAlign: "center",
        boxSizing: "border-box"
    })

    const subtitleStyles = css({
        fontSize: "14px",
        color: "gray",
        width: "100%",
        display: "block",
        paddingTop: "4px"
    })

    return (
        <div css={css({ fontFamily: "sans-serif", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" })}>
            <div css={css({ minWidth: 350 })}>
                <h1 css={css({ fontSize: 32 })}>Event RSVP</h1>
                <form css={css({
                    fontSize: 16
                })}>
                    <div css={inputContainerStyles}>
                        <div css={labelStyles}>
                            <label htmlFor="name" >Name</label>
                            <div css={subtitleStyles} > Enter your name as it was printed in your invitation </div>
                        </div>
                        <input css={textInputStyles} id="name" type="text" value={name} onChange={e => setName(e.target.value)} />
                    </div>
                    <div css={inputContainerStyles}>
                        <div css={labelStyles}>
                            <label htmlFor="name" > Guests</label>
                            <div css={subtitleStyles} > Bringing anyone? Please list their names below </div>
                        </div>
                        <input css={textInputStyles} id="name" type="text" value={guests} onChange={e => setGuests(e.target.value)} />
                    </div>
                    <div css={inputContainerStyles}>
                        <div css={labelStyles}>
                            <label htmlFor="email"> Dietary Preferences </label></div>
                        <div css={css({ marginBottom: "4px" })}>
                            <input name="diet" type="radio" checked={openForm == true} onClick={e => setOpenForm(true)} /> Yes
                        </div>
                        <div>
                            <input name="diet" type="radio" checked={openForm == false} onClick={e => setOpenForm(false)} /> No
                        </div>
                    </div>
                    {openForm &&
                        <div css={inputContainerStyles}>
                            <label htmlFor="email" css={labelStyles} > Choose Dietary Preferences </label>
                            <div>
                                <input name="diet-yes" type="checkbox" value="true" /> Shellfish Alergy
                            </div>
                            <div>
                                <input name="diet-yes" type="checkbox" value="false" /> Vegan
                            </div>
                            <div>
                                <input name="diet-yes" type="checkbox" value="false" /> Vegetarian
                            </div>
                        </div>
                    }
                    <div css={buttonStyles}>Submit</div>
                </form>
            </div>
        </div >
    )
}

export default Form;